import React from 'react'
import { Card } from 'antd'
import './index.less'

export interface PageCardProps {
	children?: React.ReactNode;
	title?: React.ReactNode;
	extra?: React.ReactNode;
}

const PageCard: React.FC<PageCardProps> = ({children, title, extra}) => {
	return (
		<Card
			className="page-card"
			title={title}
			extra={extra}
		>
			{children}
		</Card>
	)
}

export default PageCard